import { DateValue } from '@razorpay/blade/components';
import {
  UpdatePayRequest,
  UpdatePayWithSalaryStructureRequest,
} from 'api/gql-utils/payDetails/types';
import { PayrollCycle } from 'api/gql-utils/user/types';
import { getCurrentPayrollMonth } from 'components/RunPayroll/utils/utils';
import { getDate, isSameMonth } from 'date-fns';
import { convertToOrdinal } from 'utils/Dates';

export const createUpdatePayPayload = ({
  userId,
  annualSalary,
  effectiveFrom,
}: {
  userId: string;
  annualSalary: number;
  effectiveFrom: string;
}): UpdatePayRequest => {
  return {
    userId,
    payload: {
      annualSalary,
      effectiveFrom,
      allowance: [],
      basicSalary: 0,
      da: 0,
      hra: 0,
      deductions: [],
      employerESIContribution: 0,
      employerPFContribution: 0,
      isEligibleForEmployerESIContribution: false,
      isEligibleForEmployerPFContribution: false,
      isCustomSalaryStructure: false,
      lta: 0,
      flexiPartnerAllowanceAmount: 0,
      npsEmployerContributionLimit: 0,
      specialAllowance: 0,
      variablePay: '0',
      vpf: 0,
    },
  };
};

export const createUpdatePayWithSalaryStructurePayload = ({
  userId,
  annualSalary,
  effectiveFrom,
  salaryStructureId,
}: {
  userId: string;
  annualSalary: number;
  effectiveFrom: string;
  salaryStructureId: string;
}): UpdatePayWithSalaryStructureRequest => {
  return {
    userId,
    payload: {
      salaryStructureId,
      annualSalary,
      effectiveFrom,
      allowance: [],
      basicSalary: 0,
      da: 0,
      hra: 0,
      deductions: [],
      employerESIContribution: 0,
      employerPFContribution: 0,
      isEligibleForEmployerESIContribution: false,
      isEligibleForEmployerPFContribution: false,
      isCustomSalaryStructure: false,
      lta: 0,
      flexiPartnerAllowanceAmount: 0,
      npsEmployerContributionLimit: 0,
      specialAllowance: 0,
      variablePay: '0',
      vpf: 0,
    },
  };
};

export const getRevisionAlertMessageText = (
  payrollCycle: PayrollCycle,
  selectedEffectiveDate: DateValue,
) => {
  const payrollCycleStartDay = payrollCycle.startDate === 0 ? 1 : payrollCycle.startDate;

  if (selectedEffectiveDate) {
    const effectiveDay = getDate(selectedEffectiveDate);
    return `Previous salary would be considered from ${convertToOrdinal(
      payrollCycleStartDay,
    )} to ${convertToOrdinal(
      effectiveDay,
    )}. Revised compensation will be considered from ${convertToOrdinal(effectiveDay)}.`;
  }

  return '';
};

export const checkIsCurrentPayrollMonth = (selectedEffectiveDate: Date) => {
  const currentPayrollMonth = getCurrentPayrollMonth();
  return isSameMonth(currentPayrollMonth, selectedEffectiveDate);
};

export const isDateAfterPayrollCycleStartDate = (
  selectedEffectiveDate: Date,
  payrollCycle: PayrollCycle,
) => {
  return getDate(selectedEffectiveDate) > payrollCycle.startDate;
};
